import React from 'react';

import { addWithConfig } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import ActionButton from 'components/action-button';
import BellIcon from 'components/icons/bell-icon';
import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const StyledBellIcon = BellIcon.withConfig(() => ({
  size: '$5',
  position: 'relative',
}));

export const UnreadNotificationBadge = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.unreadNotificationBadge, style] });

export const BadgeText = withTypography({
  color: 'white',
  fontSize: '2xs',
  px: '$1',
  lineHeight: 10,
  style: { height: spacing.$2_5 },
});

export const StyledNotificationButton = addWithConfig(ActionButton).withConfig({
  paddingLeft: '$4',
  paddingRight: '$0',
  _web: {
    paddingLeft: '$0',
    paddingRight: '$0',
  },
});

const styles = StyleSheet.create({
  unreadNotificationBadge: {
    alignItems: 'center',
    backgroundColor: primitive.$fieryRed,
    borderRadius: 9999,
    height: spacing.$4,
    justifyContent: 'center',
    left: -16,
    minWidth: spacing.$4,
    position: 'absolute',
    top: -18,
  },
});
